"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'optionDateTimePicker',
  props: {
    value: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      dateValue: [],
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            var start = new Date(),
              end = new Date();
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var start = new Date(),
              end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近7天',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            start.setHours(0, 0, 0);
            end.setHours(23, 59, 59);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上个月',
          onClick: function onClick(picker) {
            var now = new Date();
            var start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            var end = new Date(now.getFullYear(), now.getMonth(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本月',
          onClick: function onClick(picker) {
            var now = new Date();
            var start = new Date(now.getFullYear(), now.getMonth(), 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本年',
          onClick: function onClick(picker) {
            var now = new Date();
            var start = new Date(now.getFullYear(), 0, 1);
            var end = new Date();
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  watch: {
    value: function value(nval) {
      this.dateValue = nval;
    }
  },
  created: function created() {
    this.dateValue = this.value;
  },
  methods: {
    onchangeTime: function onchangeTime(dateValue) {
      this.$emit('changeOptTime', dateValue);
    }
  }
};